var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"bg-img",attrs:{"src":"https://ysh-cdn.kaidicloud.com/test/coupon/guide-map.jpg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }